<div class="row align-items-end">
  <div class="col-9">
    <h2>Links</h2>
  </div>
  <div class="col-3 text-end"><button class="btn btn-sm btn-success" (click)="open(content)"><i
  class="bi bi-file-earmark-plus"></i>Novo</button></div>
</div>

<table mat-table [dataSource]="dataSource" matSort class="mt-2">
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Id"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Id
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
    {{element.id}} </td>
  </ng-container>
  <ng-container matColumnDef="site" class="d-none d-lg-block d-xl-none">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Site"
      class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
      Site
    </th>
    <td mat-cell *matCellDef="let element" class="d-none d-lg-table-cell d-xl-table-cell d-xxl-table-cell">
    {{element.site}} </td>
  </ng-container>
  <ng-container matColumnDef="url">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Url">
      Url
    </th>
    <td mat-cell *matCellDef="let element"> {{element.url}} </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button class="btn btn-sm" (click)="edit(content,row.id)"><i class="bi bi-pen-fill"></i></button>
        <button class="btn btn-sm" (click)="deleteItem(row.id)"><i class="bi bi-trash"></i></button>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Selecione a página">
</mat-paginator>

<ng-template #content let-c="close" let-d="dismiss">
  <form (ngSubmit)="submitForm()" [formGroup]="formLink" novalidate>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Link</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>Site</label>
        <input id="site" formControlName="site" type="text" class="form-control" required />
        @if (submitted && f.site.errors) {
          <small class="text-danger">
            @if (f.site.errors.required) {
              <span>Site é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Descrição</label>
        <textarea id="descricao" formControlName="descricao" type="text" class="form-control" rows="5"></textarea>
        @if (submitted && f.descricao.errors) {
          <small class="text-danger">
            @if (f.descricao.errors.required) {
              <span>Descrição é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Url</label>
        <input id="url" formControlName="url" type="text" class="form-control" required />
        @if (submitted && f.url.errors) {
          <small class="text-danger">
            @if (f.url.errors.required) {
              <span> Url é obrigatório.</span>
            }
          </small>
        }
      </div>
      <div class="form-group">
        <label>Url Imagem</label>
        <input id="imagem" formControlName="imagem" type="text" class="form-control" required />
        @if (submitted && f.imagem.errors) {
          <small class="text-danger">
            @if (f.imagem.errors.required) {
              <span> Imagem é obrigatório.</span>
            }
          </small>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-sm-text btn-sm btn-success">Salvar</button>
      <button type="button" class="btn btn-sm-text btn-sm btn-warning" (click)="c('Close click')">Cancelar</button>
      <input type="hidden" formControlName="id" name="id" id="id" />
    </div>
  </form>
</ng-template>